module.exports = __webpack_public_path__ + "static/img/line-left.b6fb5b40.png";